import React from "react";
import { Layout, ConfigProvider } from "antd";
import HeaderBar from "./HeaderBar";
import { useLocation } from "react-router-dom";
import { appRouter } from "../../constants/routerConstant";
import { initMessageApi } from "../../utils/toastMessageUtil";

const { Content } = Layout;

const AppLayout = ({ children }) => {
  const location = useLocation();
  const pathname = location.pathname;

  const contextHolder = initMessageApi();
  const hideHeader = pathname === appRouter.DMQLogin;

  return (
    <ConfigProvider theme={{ token: { colorPrimary: "#1677ff" } }}>
      <Layout style={{ minHeight: "100vh" }}>
        {!hideHeader && <HeaderBar />}

        <Layout>
          <Layout>
            {contextHolder}
            <Content className="app-content">{children}</Content>
          </Layout>
        </Layout>
      </Layout>
    </ConfigProvider>
  );
};

export default AppLayout;
